import { Typography } from '@workspace/ui/components/Typography';
import { cn } from '@workspace/ui/lib/utils';

import { company } from '~/company/Company';

import { LOCALE } from './constants';

interface LanguageListProps {
  variant?: 'light' | 'default';
  currentLang: string;
  onSelect: (lang: string) => void;
  className?: string;
}

export const LanguageList = ({
  variant = 'default',
  currentLang,
  onSelect,
  className,
}: LanguageListProps) => {
  return (
    <div className={cn('flex flex-col gap-4', className)}>
      {company.config.langs.map((lang) => {
        const locale = LOCALE[lang as keyof typeof LOCALE];
        if (!locale) return null;

        const isActive = lang === currentLang;
        const label = 'label' in locale ? locale.label : locale.title;

        return (
          <div key={lang}>
            {lang !== company.config.langs[0] && (
              <div
                className={cn(
                  'mb-4 h-px',
                  variant === 'light'
                    ? 'bg-graphic-transparent-white-25'
                    : 'bg-surface-transparent-3',
                )}
              />
            )}
            <button
              type="button"
              onClick={() => onSelect(lang)}
              className="flex w-full cursor-pointer items-center gap-4 border-none bg-transparent px-0 py-2 outline-none"
              aria-label={label}
            >
              <div className="flex flex-1 items-center gap-4">
                <div
                  className={cn(
                    'flex size-6 items-center justify-center rounded-full border-2',
                    isActive
                      ? 'border-action-brand bg-action-brand'
                      : variant === 'light'
                        ? 'border-stroke-inverse-primary'
                        : 'border-stroke-primary',
                  )}
                >
                  {isActive && (
                    <div className="size-2.5 rounded-full bg-bg-content" />
                  )}
                </div>
                <Typography.Text400Medium
                  className={
                    variant === 'light'
                      ? 'text-graphic-regular-white'
                      : 'text-text-primary'
                  }
                >
                  {label}
                </Typography.Text400Medium>
              </div>
              <div
                role="img"
                aria-label={locale.title}
                className="size-6 rounded-full bg-center bg-size-[200%] bg-no-repeat"
                style={{ backgroundImage: `url(${locale.img})` }}
              />
            </button>
          </div>
        );
      })}
    </div>
  );
};
